import { useNavigate } from "react-router-dom";
import { Check, ChevronsUpDown, Building2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const roleLabels = { org_owner: "Owner", org_admin: "Admin", moderator: "Moderator", viewer: "Viewer" };

export default function OrgSwitcher() {
  const { memberships, activeOrgId, switchOrg } = useAuth();
  const navigate = useNavigate();
  const active = memberships.find((m) => m.org_id === activeOrgId);

  if (!memberships.length) return null;

  const onSwitch = (orgId) => {
    switchOrg(orgId);
    navigate("/dashboard");
    setTimeout(() => window.location.reload(), 50);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="org-switcher" className="w-full flex items-center gap-2.5 rounded-md border border-white/10 bg-white/5 px-3 py-2.5 text-left hover:bg-white/10 transition-colors">
          <span className="h-8 w-8 rounded-md bg-accent/90 flex items-center justify-center shrink-0">
            {active?.org_logo ? <img src={active.org_logo} alt="" className="h-full w-full rounded-md object-cover" /> : <Building2 className="h-4 w-4 text-white" />}
          </span>
          <span className="flex-1 min-w-0">
            <span className="block text-sm font-semibold text-white truncate">{active?.org_name || "Select organisation"}</span>
            <span className="block text-[11px] text-white/50">{roleLabels[active?.role] || active?.role}</span>
          </span>
          <ChevronsUpDown className="h-4 w-4 text-white/40 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel className="text-xs text-muted-foreground">Your organisations</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {memberships.map((m) => (
          <DropdownMenuItem key={m.org_id} onClick={() => onSwitch(m.org_id)} data-testid={`org-option-${m.org_id}`} className="cursor-pointer">
            <Building2 className="h-4 w-4 mr-2 text-muted-foreground" />
            <span className="flex-1 truncate">{m.org_name}</span>
            {m.org_id === activeOrgId && <Check className="h-4 w-4 text-accent" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
